import { Tooltip } from '@mui/material';
import {
    addDays,
    endOfDay,
    format,
    getHours,
    getMinutes,
    isSameDay,
    isSameMonth,
    isWithinInterval,
    startOfDay
} from 'date-fns';
import React from 'react';
import formatTimeAgo from '../hooks/formatTimeAgo';
import { ProductAvailableDate } from '../../api/requests/interfaces/Product';

export interface TimelineProps {
    availableDates: ProductAvailableDate[];
}

export const Timeline: React.FC<TimelineProps> = ({availableDates}) => {

    const estonianMonths = [
        'JAAN', 'VEEB', 'MÄRT', 'APR', 'MAI', 'JUUNI',
        'JUULI', 'AUG', 'SEPT', 'OKT', 'NOV', 'DETS'
    ];

    const dummyAvailableDates = [
        {
            startDate: new Date(2024, 11, 15),
            endDate: new Date(2024, 11, 22)
        },
        {
            startDate: new Date(2024, 11, 24),
            endDate: new Date(2024, 11, 25)
        },
        {
            startDate: new Date(2024, 11, 26, 10, 0),
            endDate: new Date(2024, 11, 28, 15, 0)
        },
        {
            startDate: new Date(2025, 0, 1, 19, 0),
            endDate: new Date(2025, 0, 3, 12, 23)
        },
        {
            startDate: new Date(2025, 0, 6, 12, 30),
            endDate: new Date(2025, 0, 6, 19, 23)
        },
        {
            startDate: new Date(2025, 0, 8, 12, 30),
            endDate: new Date(2025, 0, 8, 13, 30)
        },
        {
            startDate: new Date(2025, 0, 8, 14, 30),
            endDate: new Date(2025, 0, 8, 15, 30)
        }
    ]

    const getNext30Dates = () => {
        const days = [];
        const today = new Date();

        console.log("availabledates: " + JSON.stringify(availableDates))

        for (let i = 0; i < 30; i++) {
            const nextDay = addDays(today, i); // Add 'i' days to today
            days.push(nextDay);
        }
        return days;
    };

    const datesArray = getNext30Dates();

    const formatToTime = (hours: number, minutes: number) => {
        return hours.toString().padStart(2, "0") + ":" + minutes.toString().padStart(2, "0");
    }

    const dayStatus = (day: Date) => {
        for (const item of availableDates) {
            if (!item.startDate || !item.endDate) {
                continue;
            }

            const itemDates = [];

            // Determine if day is half-booked (has hour specification) or not
            if (isWithinInterval(day, { start: startOfDay(item.startDate), end: endOfDay(item.endDate) })) {
                const startDateHours = getHours(item.startDate);
                const startDateMinutes = getMinutes(item.startDate);
                const endDateHours = getHours(item.endDate);
                const endDateMinutes = getMinutes(item.endDate);

                for (const i of availableDates) { // TODO: More complex logic to show available time slots inside a single day to the user
                    if (isSameDay(i.startDate, day)) { itemDates.push(i.startDate); }
                    if (isSameDay(i.endDate, day)) { itemDates.push(i.endDate); }
                }
                if (itemDates.length > 2) { return { status: "partially_available", timeComponent: "Uuri infot saadavuse kohta rentijalt." } }

                if (isSameDay(item.startDate, item.endDate)) {
                    return { status: "partially_available", timeComponent: "Broneeritud " + formatToTime(
                        getHours(item.startDate), getMinutes(item.startDate)) + "-" +
                            formatToTime(getHours(item.endDate), getMinutes(item.endDate)) }
                }


                if (isSameDay(item.startDate, day) && (startDateHours !== 0 || startDateMinutes !== 0)) {
                    return { status: "partially_available", timeComponent: "Saadaval alates: " + formatToTime(startDateHours, startDateMinutes) };
                }

                if (isSameDay(item.endDate, day) && (endDateHours !== 0 || endDateMinutes !== 0)) {
                    return { status: "partially_available", timeComponent: "Saadaval kuni: " + formatToTime(endDateHours, endDateMinutes) };
                }

                return { status: "available", timeComponent: null };
            }
        }

        // Default status
        return { status: "unavailable", timeComponent: null };
    };

    return (
        <div className="flex flex-row items-stretch flex-wrap gap-y-2">
            {datesArray.map((day, index) => {

                const { status: currentDay, timeComponent: currentDayTime } = dayStatus(day);

                if (!isSameMonth(day, datesArray[index - 1])) {

                    return <Tooltip title={currentDay === "available" ? 'Terve päev saadaval' : currentDay === "unavailable" ? 'Terve päev kinni broneeritud' : currentDayTime} placement='top' arrow><div className="flex flex-col gap-1">
                        <div
                            key={index}
                            className={`basis-full w-full min-w-[15px] min-h-2 ${currentDay === "available" ? 'bg-green-300' : currentDay === "unavailable" ? 'bg-red-300' : "bg-yellow-300"}`}
                            style={{ margin: '0', padding: '0', borderRight: '1px solid white' }}
                        >
                        </div>
                        <p className="text-[12px] text-gray-600 text-left pr-1.5">{estonianMonths[day.getMonth()]}</p>
                    </div></Tooltip>;
                }
                if (day.getDate() % 2 !== 0) {
                    return <Tooltip title={currentDay === "available" ? 'Terve päev saadaval' : currentDay === "unavailable" ? 'Terve päev kinni broneeritud' : currentDayTime} placement='top' arrow>
                        <div className="min-h-full min-w-[15px] max-w-[15px]">
                            <div
                                key={index}
                                className={`flex-1 basis-full  min-h-2 ${currentDay === "available" ? 'bg-green-300' : currentDay === "unavailable" ? 'bg-red-300' : "bg-yellow-300"}`}
                                style={{ margin: '0', padding: '0', borderRight: '1px solid white' }}
                            >

                            </div>
                        </div>
                    </Tooltip>;
                }

                return (
                    <Tooltip title={currentDay === "available" ? 'Terve päev saadaval' : currentDay === "unavailable" ? 'Terve päev kinni broneeritud' : currentDayTime} placement='top' arrow>
                        <div className="min-w-[15px] max-w-[15px] flex-1 flex flex-col gap-1">
                            <div
                                key={index}
                                className={`basis-full min-w-[10px] min-h-2 ${currentDay === "available" ? 'bg-green-300' : currentDay === "unavailable" ? 'bg-red-300' : "bg-yellow-300"}`}
                                style={{ margin: '0', padding: '0', borderRight: '1px solid white' }}
                            >

                            </div>
                            <p className="text-[12px] text-gray-600 text-center">{day.getDate()}</p>
                        </div>
                    </Tooltip>
                );
            })}
        </div>
    );

};